/*
 * Rooana: прозорец „Често купувани заедно“.
 * Отваря се след успешно добавяне от продуктовата форма (source: 'product-form'),
 * вместо стандартното известие за количката.
 */
if (!customElements.get('rooana-upsell')) {
  customElements.define(
    'rooana-upsell',
    class RooanaUpsell extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('.rooana-upsell__dialog');
        this.items = Array.from(this.querySelectorAll('.rooana-upsell__item'));
        this.errorEl = this.querySelector('.rooana-upsell__error');
        this.maxShows = parseInt(this.dataset.maxShows, 10) || 3;
        this.maxItems = parseInt(this.dataset.maxItems, 10) || 3;
        this.storageKey = 'rooana-upsell-shows';
        this.onKeyUp = (evt) => evt.key === 'Escape' && this.close();

        this.querySelectorAll('[data-upsell-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        this.addEventListener('click', (evt) => {
          const button = evt.target.closest('button[data-variant-id]');
          if (button) this.addItem(button);
        });
      }

      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!event || event.source !== 'product-form') return;
          // Изчакваме стандартното известие да се отвори, след това го заменяме.
          setTimeout(() => this.maybeOpen(event), 350);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      getShows() {
        try {
          return parseInt(sessionStorage.getItem(this.storageKey), 10) || 0;
        } catch (e) {
          return 0;
        }
      }

      setShows(value) {
        try {
          sessionStorage.setItem(this.storageKey, String(value));
        } catch (e) {
          /* без запис – прозорецът просто може да се покаже отново */
        }
      }

      async maybeOpen(event) {
        if (this.getShows() >= this.maxShows) return;

        const addedProductId = event.cartData && event.cartData.product_id ? String(event.cartData.product_id) : null;
        const addedIsGeske = event.cartData && /geske/i.test(event.cartData.vendor || '');

        let inCart = new Set();
        try {
          const cart = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
          inCart = new Set(cart.items.map((item) => String(item.product_id)));
        } catch (e) {
          /* ако не успеем, просто не филтрираме по количката */
        }

        let geskeShown = addedIsGeske ? 1 : 0; // ако току-що е добавен GESKE, не предлагаме втори уред
        let shown = 0;
        this.items.forEach((item) => {
          const id = item.dataset.productId;
          const isGeske = item.dataset.geske === 'true';
          let show = shown < this.maxItems && id !== addedProductId && !inCart.has(id);
          if (show && isGeske) {
            if (geskeShown >= 1) show = false;
            else geskeShown += 1;
          }
          item.hidden = !show;
          if (show) shown += 1;
          this.resetButton(item);
        });

        if (shown === 0) return;

        const notification = document.querySelector('cart-notification');
        if (notification && typeof notification.close === 'function') notification.close();

        this.open();
        this.setShows(this.getShows() + 1);
      }

      resetButton(item) {
        const button = item.querySelector('button[data-variant-id]');
        if (!button) return;
        button.disabled = false;
        button.classList.remove('is-added', 'loading');
        button.textContent = 'Добави';
      }

      open() {
        this.previousFocus = document.activeElement;
        if (this.errorEl) this.errorEl.hidden = true;
        this.hidden = false;
        document.body.classList.add('rooana-upsell-open');
        void this.offsetWidth; // принудително прерисуване, за да тръгне анимацията
        this.classList.add('is-open');
        document.addEventListener('keyup', this.onKeyUp);
        this.dialog.focus();
        if (typeof trapFocus === 'function') trapFocus(this.dialog);
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('rooana-upsell-open');
        document.removeEventListener('keyup', this.onKeyUp);
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.previousFocus);
        setTimeout(() => {
          this.hidden = true;
        }, 200);
      }

      async addItem(button) {
        if (button.disabled) return;
        button.disabled = true;
        button.classList.add('loading');
        if (this.errorEl) this.errorEl.hidden = true;

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
              sections: 'cart-icon-bubble',
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'add-failed');

          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections && data.sections['cart-icon-bubble']) {
            const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            const inner = html.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }

          button.classList.remove('loading');
          button.classList.add('is-added');
          button.textContent = 'Добавено';

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rooana-upsell', productVariantId: button.dataset.variantId });
          }
        } catch (error) {
          button.disabled = false;
          button.classList.remove('loading');
          if (this.errorEl) this.errorEl.hidden = false;
          // eslint-disable-next-line no-console
          console.error('[rooana-upsell]', error);
        }
      }
    }
  );
}
